module.exports = __webpack_public_path__ + "static/media/20.d90065b0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/20.JPG
// module id = 463
// module chunks = 0